module.exports = __webpack_public_path__ + "/login_ui/img/tv-a1651a792cbe1793ad1907e0ce65b839.svg";